export const Null = () => {
    return (
        <div>
            There was an error with this URL.  It appears to be invalid. Please use the links above to navigate to a working page.
            Thank you!
        </div>
    )
}

export default Null;